export const UploadCsvStepsNames = {
  SIGNUP: 'SIGNUP',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  UPLOAD_CSV_FILE: 'UPLOAD_CSV_FILE',
  UPLOADING_FILE: 'UPLOADING_FILE',
  PROCESSING_DATA: 'PROCESSING_DATA',
  GENERATING_REPORT: 'GENERATING_REPORT',
  LINK_EMAIL_VALIDATION: 'LINK_EMAIL_VALIDATION',
};


export const uploadCsvSteps = {
    [UploadCsvStepsNames.SIGNUP]:
      {
        key:UploadCsvStepsNames.SIGNUP,
        title: 'Signup',
        description: 'Please enter your email to sign up',
        isComplete: false,
        isActive: false,
      },
   [UploadCsvStepsNames.VERIFY_EMAIL]:
      {key:UploadCsvStepsNames.VERIFY_EMAIL,
        title: 'VERIFY EMAIL',
        description: 'Please verify your email',
        isComplete: false,
        isActive: false,
      },
  [UploadCsvStepsNames.UPLOAD_CSV_FILE]:
      {key:UploadCsvStepsNames.UPLOAD_CSV_FILE,
        title: 'UPLOAD CSV',
        description: 'Please upload a CSV with Survey responses to get started',
        isComplete: false,
        isActive: false,
      },
   [UploadCsvStepsNames.UPLOADING_FILE]:
      {key:UploadCsvStepsNames.UPLOADING_FILE,
        title: 'UPLOADING FILE',
        description: 'File is being processed',
        isComplete: false,
        isActive: false,
      },
  [UploadCsvStepsNames.PROCESSING_DATA]:
      {key:UploadCsvStepsNames.PROCESSING_DATA,
        title: 'PROCESSING DATA',
        description: 'Data is being processed',
        isComplete: false,
        isActive: false,
      },
   [UploadCsvStepsNames.GENERATING_REPORT]:
      {key:UploadCsvStepsNames.GENERATING_REPORT,
        title: 'GET GENERATED REPORT',
        description: 'Get AI generated report, customize report and download or share ',
        isComplete: false,
        isActive: false,
      },
  }
;